import { render, staticRenderFns } from "./CogAI.vue?vue&type=template&id=3b6a1a44&scoped=true&"
import script from "./CogAI.vue?vue&type=script&lang=js&"
export * from "./CogAI.vue?vue&type=script&lang=js&"
import style0 from "./CogAI.vue?vue&type=style&index=0&id=3b6a1a44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6a1a44",
  null
  
)

export default component.exports